import { AttachmentModal } from '@/utils/enums';
import { Checkbox } from 'antd';
import {
  FolderAddOutlined,
  FolderOutlined,
  PaperClipOutlined,
} from '@ant-design/icons';
import { useState } from 'react';
import ModalAddFiles from '../Modals/ModalAddFiles';
import ModalAddFolders from '../Modals/ModalAddFolder';
import { useTranslation } from 'react-i18next';

export const ChatAttachment = ({
  inquiryId,
  inquiry,
  setReloadInquiry,
  reloadData,
  children,
}: any) => {
  const { t } = useTranslation();
  const attachments = inquiry?.attachments || [];
  const folders = inquiry?.folders || [];
  const isFoldersEmpty = !folders || folders.length === 0;
  const isAttachmentsEmpty = !attachments || attachments.length === 0;

  const [openModal, setOpenModal] = useState<AttachmentModal | null>(null);
  const [isUploading, setIsUploading] = useState<boolean>(false);

  const handleOpenAddFolderModal = () => {
    setOpenModal(AttachmentModal.FOLDER);
  };

  const handleOpenAddFilesModal = () => {
    setOpenModal(AttachmentModal.FILES);
  };

  const handleCloseDeleteModal = () => {
    if (isUploading) {
      return;
    }
    setOpenModal(null);
  };

  const folderAttachments = () => {
    if (isFoldersEmpty) {
      return (
        <div
          style={{
            display: 'flex',
            gap: 10,
            fontSize: ' 16px',
            cursor: 'pointer',
          }}
          onClick={handleOpenAddFolderModal}
        >
          <FolderAddOutlined style={{ fontSize: '25px', color: '#00000073' }} />
          <span style={{ color: '#056FF6', fontWeight: 300 }}>
            {t('home.chat.folderAttachments')}
          </span>
        </div>
      );
    }
    return (
      <div
        style={{
          display: 'flex',
          gap: 10,
          fontSize: ' 16px',
          cursor: 'pointer',
        }}
        onClick={handleOpenAddFolderModal}
      >
        <FolderOutlined style={{ fontSize: '25px', color: '#00000073' }} />
        <span style={{ color: '#056FF6', fontWeight: 300 }}>
          {t('home.chat.folderAttachments')}
        </span>
      </div>
    );
  };

  const getFileAttachments = () => {
    if (isAttachmentsEmpty) {
      return (
        <div
          style={{
            display: 'flex',
            gap: 10,
            fontSize: ' 16px',
            cursor: 'pointer',
          }}
          onClick={handleOpenAddFilesModal}
        >
          <PaperClipOutlined style={{ fontSize: '25px', color: '#00000073' }} />
          <span>{t('home.chat.fileAttachments')}</span>
        </div>
      );
    }
    return (
      <div
        style={{
          display: 'flex',
          gap: 10,
          fontSize: ' 16px',
          cursor: 'pointer',
        }}
        onClick={handleOpenAddFilesModal}
      >
        <PaperClipOutlined
          onClick={handleOpenAddFilesModal}
          style={{ fontSize: '25px', color: '#00000073' }}
        />
        <span>{t('home.chat.fileAttachments')}</span>
      </div>
    );
  };

  return (
    <div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 10,
          background: '#FAFAFA',
          border: '1px solid #F0F0F0',
          padding: '10px',
          marginLeft: '16px',
          color: '#00000073',
        }}
      >
        {folderAttachments()}
        <span>{t('home.chat.linkingWord')}</span>
        {getFileAttachments()}
        {children}
      </div>
      <ModalAddFolders
        inquiryId={inquiryId}
        inquiry={inquiry}
        setReloadInquiry={setReloadInquiry}
        open={openModal == AttachmentModal.FOLDER}
        onCancel={handleCloseDeleteModal}
        reloadData={reloadData}
      />
      <ModalAddFiles
        inquiryId={inquiryId}
        inquiry={inquiry}
        setReloadInquiry={setReloadInquiry}
        open={openModal == AttachmentModal.FILES}
        onCancel={handleCloseDeleteModal}
        externalLoading={isUploading}
        setExternalLoading={setIsUploading}
      />
    </div>
  );
};
